import { render, staticRenderFns } from "./context-comments-options.vue?vue&type=template&id=116e514a"
import script from "./context-comments-options.vue?vue&type=script&lang=js"
export * from "./context-comments-options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports